export default "__VITE_ASSET__DvgKWo9s__"